
import React from 'react';
import runewords from '../data/runewords';
import Page from '../components/Page';
import runes from '../data/runes';
import { IonBadge, IonButton, IonButtons, IonIcon } from '@ionic/react';
import { information, informationCircle, star, starOutline } from 'ionicons/icons';

class RunewordDetails extends React.Component {

  state = {}

  componentDidMount() {
    const result = runewords.filter(r => r.id == this.props.match.params.id);
    this.setState({runeword: result[0]});
  }

  renderStats() {
    return this.state.runeword.attributes.map((stat,i) => 
        <p key={i} className="d2font stat" style={{color: '#538ff7'}}>{stat}</p>
      )
  }

  getRequiredLevel() {
    // considers only the runewords
    const levels = this.state.runeword.runes.map(r => runes[r].level);
    return Math.max(...levels);
  }

  render() {
    if(!this.state.runeword) return <Page />
    let favRunewords = JSON.parse(localStorage.getItem('favRunewords'))
    const favorited = favRunewords.includes(this.state.runeword.name)
    return (
      <Page title={this.state.runeword.name} padding renderButtonsRight={() => 
        <IonButtons>
          <IonButton color="secondary" onClick={() => {
            if(!favorited) favRunewords.push(this.state.runeword.name);
            else favRunewords = favRunewords.filter(r => r !== this.state.runeword.name);
            localStorage.setItem('favRunewords',JSON.stringify(favRunewords));
            this.forceUpdate();
          }}><IonIcon icon={favorited ? star : starOutline}/></IonButton>
        </IonButtons>}
      >
        <div style={{textAlign: 'center'}}>
          <h2 className="d2font">{this.state.runeword.name}</h2>
          <p>{this.state.runeword.runes.reduce((c,a) => c + ' + ' +a)}</p>
          <p style={{color: '#aaa'}}>{this.state.runeword.runes.length} socket {this.state.runeword.itemType}</p>
          <p style={{color: '#aaa'}}>
            Required level from runes: {this.getRequiredLevel()}
          </p>
          <br />
          {this.renderStats()}
        </div>
      </Page>
    );
  }
}

export default RunewordDetails;